import React from "react";
import PartnerDashBoard from "../../components/PartnerDashboard/PartnerDashBoard";
const PartnerDashBoardContainers = () => {

  return <PartnerDashBoard />;
};

export default PartnerDashBoardContainers;
